


































import {Component, Vue, Prop} from 'vue-property-decorator';
import {enhancedEcommerce} from "../../shared/helpers/enhanced-ecommerce";

@Component({
  name: 'catalog-product-list-item'
})
export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({required: false}) readonly product: object;
  @Prop({default: null}) readonly type: string | null;


  private get productImage(): string {
    const imageGallery = this.product.hasOwnProperty('image_gallery') ? JSON.parse(this.product['image_gallery']) : {};
    return (Object.keys(imageGallery).length && imageGallery.hasOwnProperty('400')) ? imageGallery['400'][0] : '';
  }

  private get listType(): string {
    if (this.type === 'product') {
      return 'product-list-item';
    }
    if (this.type === 'home') {
      return 'home-product-item';
    }
    if (this.type === 'wishlist') {
      return 'small-12 medium-6 cell list-product-item';
    }
    return 'small-12 medium-8 cell list-product-item';
  }

  private addProductClick(): void {
    enhancedEcommerce.addProductClick(this.product, this.$vnode.key);
  }

  private mounted(): void {
    this.$forceUpdate();
  }

  private updated(): void {
    this.$eventBus.$emit('item-rendered', true);
    this.$nextTick(() => {
      ('.image__holder').matchHeight(true);
      const resizeEvent = new UIEvent('resize');
      window.dispatchEvent(resizeEvent);
    });
  }

  private async toggleWishlist(): Promise<void> {
    try {
      await this.$store.dispatch('CustomerWishlist/toggleWishlistProduct', this.product['product_id']);
      await this.$store.dispatch('CustomerWishlist/updateWishlistCount', false);
      window.location.reload();
    } catch (e) {
      console.log(e);
    }
  }
}
